import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const ChevronUp24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M12.0477 7.5C12.3985 7.5 12.6992 7.65123 12.8996 7.90329L17.7606 13.4485C18.1114 13.8014 18.0613 14.4063 17.7105 14.7592C17.3597 15.1121 16.7584 15.0617 16.4076 14.7088C16.4076 14.7088 16.4076 14.7088 16.3575 14.6584L12.0978 9.81891C12.0477 9.7685 11.9976 9.7685 11.8974 9.81891L7.63776 14.6584C7.28696 15.0617 6.73572 15.1121 6.33481 14.7592C5.93391 14.4063 5.88379 13.8518 6.23459 13.4485C6.23459 13.4485 6.23459 13.4485 6.2847 13.3981L11.1457 7.85288C11.3962 7.65123 11.6969 7.5 12.0477 7.5Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
